import {Promise, strings} from "@securionpay-internal/commons-js";

function generateId(): string {
    if (window.crypto && (typeof window.crypto.randomUUID === 'function')) {
        return window.crypto.randomUUID()
    }
    return strings.guid()
}


export class PaymentRequestMockForUnsupportedBrowser implements PaymentRequest {
    id: string;

    onpaymentmethodchange = null

    constructor(methodData: PaymentMethodData[], details: PaymentDetailsInit) {
        this.id = details.id || generateId()
    }

    canMakePayment(): Promise<boolean> {
        return Promise.resolve(false);
    }

    abort(): Promise<void> {
        return Promise.resolve(undefined);
    }

    show(): Promise<PaymentResponse> {
        return Promise.reject(this.notSupportedError());
    }

    dispatchEvent(): boolean {
        throw this.notSupportedError();
    }

    addEventListener(): void {
    }

    removeEventListener(): void {
    }

    private notSupportedError() {
        return new Error("PaymentRequest API not supported in this browser, call canMakePayment() before any interactions.");
    }

}